import React, { Component } from "react";
import PropTypes from "prop-types";
import { TextField, Tooltip } from "@mui/material";
import debounce from "lodash.debounce";

import "./css/InputText.css";

class InputText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue || "",
    };

    this.handleChangeDebounced = debounce(
      this.handleChangeDebounced.bind(this),
      props.debounce,
    );
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({ value: this.props.defaultValue || "" });
    }
  }

  handleChangeDebounced(newValue) {
    const { id, changeHandler } = this.props;
    if (id.split("_")[1] === "serial") {
      const arr = newValue
        .split(",")
        .filter((serial) => serial.trim() !== "")
        .map((serial) => serial.trim());
      changeHandler(arr, id);
    } else {
      changeHandler(newValue, id);
    }
  }

  handleChange(event) {
    const newValue = this.props.numbersOnly
      ? event.target.value.replace(/\D/g, "")
      : event.target.value;
    this.setState({ value: newValue });
    this.handleChangeDebounced(newValue);
  }

  blockInvalidNumberInputChars = (event) => {
    const blockedKeys = ["e", "E", "+", "-"];
    if (blockedKeys.includes(event.key)) {
      event.preventDefault();
    }
  };

  render() {
    const {
      id,
      tooltip,
      multiline,
      label,
      password,
      sx,
      required,
      className,
      helperText,
      numbersOnly,
    } = this.props;
    const { value } = this.state;

    return (
      <Tooltip title={tooltip} placement="top">
        <TextField
          id={id}
          className={`input_${id.split("_")[1]} ${className}`}
          multiline={multiline}
          label={label}
          value={value}
          onChange={this.handleChange}
          onKeyDown={
            numbersOnly ? this.blockInvalidNumberInputChars : undefined
          }
          type={password ? "password" : "text"}
          inputProps={
            numbersOnly
              ? {
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }
              : undefined
          }
          sx={sx}
          autoComplete="new-password"
          required={required}
          InputProps={this.props.InputProps}
          helperText={helperText}
        />
      </Tooltip>
    );
  }
}

InputText.propTypes = {
  changeHandler: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  multiline: PropTypes.bool,
  sx: PropTypes.object,
  debounce: PropTypes.number,
  tooltip: PropTypes.string,
  password: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  InputProps: PropTypes.object,
  helperText: PropTypes.string,
  numbersOnly: PropTypes.bool,
};

InputText.defaultProps = {
  multiline: false,
  debounce: 1000,
  tooltip: "",
  required: false,
  sx: {},
  className: "",
  InputProps: {},
  helperText: "",
  numbersOnly: false,
};

export default InputText;
